export enum BackupDeviceType {
    CIFS = 1,
    NFS = 2
}

export function getDeviceTypeString(deviceType?: number){
    if(deviceType != null){
        return BackupDeviceType[deviceType]
    }

    return ''
}
